import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Config } from '../config/env.config';
import { BaseHttpService } from '../base/_base-http.service';
import { contentHeaders } from 'common/headers';
import {catchError} from 'rxjs/operators';


@Injectable()
export class ReportsService extends BaseHttpService {

  public getCompleted(brandId: string, reportIds: any): Observable<any> {
    const body = JSON.stringify({reportIds});
    return this.http.post(
      `${Config.API}/reports/${brandId}/completed`,
      body,
      {headers: contentHeaders}
    )
        .pipe(catchError(this.handleError.bind(this)));
  }

  public getTypes(brandId: string): Observable<any> {
    return this.http.get(
      `${Config.API}/reports/${brandId}/types`,
      {headers: contentHeaders}
    )
        .pipe(catchError(this.handleError.bind(this)));
  }

  public postReport(brandId: string, reportTypeId: string, filter: any): Observable<any> {
    const body = JSON.stringify({ filter });

    return this.http.post(
      `${Config.API}/reports/${brandId}/${reportTypeId}`,
      body,
      {headers: contentHeaders}
    )
        .pipe(catchError(this.handleError.bind(this)));
  }
}
